<div class="pins-by-provider">
    <nz-card>
        <div class="header">
            <div class="title-block">
                <h2>Provider Overrides</h2>
                <p>Grant a CRM user access to every pin for a specific provider.</p>
            </div>
            <nz-tag nzColor="blue">Super Admin Only</nz-tag>
        </div>

        <nz-alert nzType="info" nzShowIcon nzMessage="Heads up" [nzDescription]="helperDescription">
        </nz-alert>

        <div class="meta-row">
            <div class="meta-card">
                <span class="meta-label">CRM Users Loaded</span>
                <span class="meta-value">{{ users.length || 0 }}</span>
            </div>
            <div class="meta-card">
                <span class="meta-label">Providers Available</span>
                <span class="meta-value">{{ providers.length || 0 }}</span>
            </div>
        </div>

        <form nz-form [formGroup]="addForm" class="form-body">
            <nz-form-item>
                <nz-form-label [nzSpan]="6" nzRequired>CRM User</nz-form-label>
                <nz-form-control [nzSpan]="18" nzErrorTip="Select a CRM user">
                    <nz-select nzShowSearch [nzLoading]="usersLoading" nzPlaceHolder="Select CRM user"
                        formControlName="userId" style="width: 100%;" nzNotFoundContent="No CRM users found">
                        <nz-option *ngFor="let user of usersList"
                            [nzLabel]="(user?.first_name || '') + ' ' + (user?.last_name || '') + ' · ' + (user?.user_id || 'N/A')"
                            [nzValue]="user?.user_id"></nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSpan]="6" nzRequired>Provider</nz-form-label>
                <nz-form-control [nzSpan]="18" nzErrorTip="Select a provider">
                    <nz-select [nzLoading]="providersLoading" nzPlaceHolder="Select provider"
                        formControlName="providerId" style="width: 100%;" nzShowSearch>
                        <nz-option *ngFor="let p of providers" [nzLabel]="p.name" [nzValue]="p.id"></nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>

            <div class="actions">
                <button nz-button nzType="default" class="ghost" type="button" (click)="addForm.reset()"
                    [disabled]="submitting">
                    Reset
                </button>

                <button nz-button nzType="primary" [disabled]="addForm.invalid || submitting" [nzLoading]="submitting"
                    (click)="submit()">
                    Save Access
                </button>
            </div>
        </form>
    </nz-card>

    <ng-template #helperDescription>
        Both selections come from live CRM data. The override is stored in <code>pins_by_provider</code> once you click
        save.
    </ng-template>
</div>